// Store locations with coordinates and IDs
const storeLocations = {
  'resita': {
    name: 'Magazin Resita',
    phones: ['0783-230-060', '0783-230-061'],
    phoneLinks: ['+40783230060', '+40783230061'],
    coordinates: {
      lat: 45.2981,
      lng: 21.8897
    },
    inventoryId: '100951458117'
  },
  'caransebes': {
    name: 'Magazin Caransebes',
    phones: ['0783-230-030', '0783-230-031'],
    phoneLinks: ['+40783230030', '+40783230031'],
    coordinates: {
      lat: 45.4167,
      lng: 22.2167
    },
    inventoryId: '100951556421'
  }
};

// Map inventory IDs to location keys
const inventoryIdToLocation = {
  '100951458117': 'resita',
  '100951556421': 'caransebes'
};

// Haversine formula
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function findClosestStore(userLat, userLng) {
  let closestStore = null;
  let minDistance = Infinity;
  for (const [key, store] of Object.entries(storeLocations)) {
    const distance = calculateDistance(userLat, userLng, store.coordinates.lat, store.coordinates.lng);
    console.log('Distance to ' + store.name + ': ' + distance.toFixed(2) + ' km');
    if (distance < minDistance) {
      minDistance = distance;
      closestStore = key;
    }
  }
  console.log('Closest store: ' + storeLocations[closestStore].name + ' (' + minDistance.toFixed(2) + ' km)');
  return closestStore;
}

function updateHeaderPhone(locationKey) {
  const location = storeLocations[locationKey];
  if (!location) {
    console.warn('Invalid location key:', locationKey);
    return;
  }
  
  // Find ALL phone number links in the header
  const phoneLinks = document.querySelectorAll('a[href^="tel:"]');
  
  if (phoneLinks.length >= 2) {
    // Update phone 1
    phoneLinks[0].href = 'tel:' + location.phoneLinks[0];
    phoneLinks[0].textContent = location.phones[0];
    
    // Update phone 2
    phoneLinks[1].href = 'tel:' + location.phoneLinks[1];
    phoneLinks[1].textContent = location.phones[1];
    
    // Remove everything between the two phone links
    let node = phoneLinks[0].nextSibling;
    while (node && node !== phoneLinks[1]) {
      const nextNode = node.nextSibling;
      node.parentNode.removeChild(node);
      node = nextNode;
    }
    
    // Add proper spacing between phones: " , "
    const spacer = document.createTextNode(' , ');
    phoneLinks[0].parentNode.insertBefore(spacer, phoneLinks[1]);
    
    // Check if there's already a <br> after second phone
    let hasBr = false;
    if (phoneLinks[1].nextSibling && phoneLinks[1].nextSibling.tagName === 'BR') {
      hasBr = true;
    }
    
    // Add line break after second phone if not exists
    if (!hasBr) {
      const br = document.createElement('br');
      phoneLinks[1].parentNode.insertBefore(br, phoneLinks[1].nextSibling);
    }
    
    console.log('Phone numbers updated for: ' + location.name);
    console.log('Phone 1: ' + location.phones[0]);
    console.log('Phone 2: ' + location.phones[1]);
  } else {
    console.warn('Could not find phone number links in header. Found: ' + phoneLinks.length);
  }
}

function saveLocationPreference(locationKey) {
  try {
    localStorage.setItem('customerLocation', locationKey);
    localStorage.setItem('locationLastUpdated', Date.now());
    console.log('Location saved: ' + locationKey);
    updateHeaderPhone(locationKey);
    
    // Dispatch event for inventory system
    window.dispatchEvent(new CustomEvent('storeLocationUpdated', {
      detail: { location: locationKey, store: storeLocations[locationKey] }
    }));
  } catch (error) {
    console.error('Error saving location:', error);
  }
}

function detectAndSetClosestStore() {
  const lastUpdated = localStorage.getItem('locationLastUpdated');
  const oneDayInMs = 24 * 60 * 60 * 1000;
  
  if (lastUpdated && (Date.now() - parseInt(lastUpdated)) < oneDayInMs) {
    const savedLocation = localStorage.getItem('customerLocation');
    if (savedLocation && storeLocations[savedLocation]) {
      console.log('Using cached location: ' + savedLocation);
      updateHeaderPhone(savedLocation);
      return;
    }
  }
  
  if (!('geolocation' in navigator)) {
    console.warn('Geolocation not supported');
    saveLocationPreference('resita');
    return;
  }
  
  console.log('Requesting user location...');
  
  navigator.geolocation.getCurrentPosition(
    function(position) {
      const userLat = position.coords.latitude;
      const userLng = position.coords.longitude;
      console.log('User location: ' + userLat + ', ' + userLng);
      const closestStore = findClosestStore(userLat, userLng);
      saveLocationPreference(closestStore);
    },
    function(error) {
      console.error('Geolocation error:', error.message);
      const savedLocation = localStorage.getItem('customerLocation');
      if (savedLocation && storeLocations[savedLocation]) {
        updateHeaderPhone(savedLocation);
      } else {
        saveLocationPreference('resita');
      }
    },
    {
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 300000
    }
  );
}

// Get store location from the select dropdown
function getStoreFromSelect() {
  const select = document.getElementById('iia-locations-select');
  if (!select) return null;
  
  const selectedValue = select.value;
  const locationKey = inventoryIdToLocation[selectedValue];
  
  if (locationKey) {
    console.log('Select value: ' + selectedValue + ' -> ' + locationKey);
    return locationKey;
  }
  
  return null;
}

// Watch for changes to the location select dropdown
function watchLocationSelect() {
  console.log('Looking for location select element...');
  
  const checkForSelect = function() {
    const select = document.getElementById('iia-locations-select');
    
    if (select) {
      console.log('Found location select element!');
      
      // Listen for change events on the select
      select.addEventListener('change', function(e) {
        const selectedValue = e.target.value;
        const locationKey = inventoryIdToLocation[selectedValue];
        
        if (locationKey) {
          console.log('Location changed in dropdown: ' + locationKey);
          saveLocationPreference(locationKey);
        } else {
          console.log('Unknown location selected: ' + selectedValue);
        }
      });
      
      // Also check the current selected value on load
      const currentLocation = getStoreFromSelect();
      if (currentLocation) {
        const savedLocation = localStorage.getItem('customerLocation');
        if (currentLocation !== savedLocation) {
          console.log('Syncing with dropdown selection: ' + currentLocation);
          saveLocationPreference(currentLocation);
        }
      }
      
      return true;
    }
    
    return false;
  };
  
  // Try to find the select immediately
  if (checkForSelect()) {
    return;
  }
  
  // If not found, wait for it to appear
  console.log('Select not found yet, watching for it...');
  
  const observer = new MutationObserver(function(mutations) {
    if (checkForSelect()) {
      console.log('Select element appeared, stopping observer');
      observer.disconnect();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Also try checking periodically
  let attempts = 0;
  const checkInterval = setInterval(function() {
    attempts++;
    if (checkForSelect() || attempts > 20) {
      clearInterval(checkInterval);
    }
  }, 500);
}

// Manual store selection function
window.setStoreLocation = function(locationKey) {
  if (storeLocations[locationKey]) {
    saveLocationPreference(locationKey);
    console.log('Location manually set to: ' + locationKey);
    return true;
  } else {
    console.error('Invalid location key: ' + locationKey);
    return false;
  }
};

function init() {
  console.log('Store Location System: Initializing...');
  
  setTimeout(function() {
    detectAndSetClosestStore();
    watchLocationSelect();
  }, 500);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
